import { useState, useEffect } from "react";

function useSearchInCountry(searchedText, countries) {
    const [searchedData, setsearchedData] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        let timeout = null;
        if (searchedText) {
            setIsSearching(true);
            timeout = setTimeout(() => {
                setsearchedData(countries.filter((country) => country.name.toLocaleLowerCase().includes(searchedText.toLocaleLowerCase())));
                setIsSearching(false);
            }, 500);
        } else {
            setsearchedData([]);
            setIsSearching(false);
        }
        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [searchedText, countries]);

    return { searching: isSearching, searched: searchedData };
}

export default useSearchInCountry;
